export default [{
  path: '/order/choose-lip',
  name: 'choose-lip',
  component: () => import('@/pages/order/lip-guoqing-temp/index.vue'),
  meta: {
    name: '下单-选择口红赠品',
    description: '下单-选择口红赠品',
  }
}]